var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"interOrderHN"},[_c('order-search',{ref:"orderSearch",attrs:{"searchColumns":_vm.searchColumns,"searchForm":_vm.searchForm,"columnList":_vm.columnList,"reserve":true,"api":_vm.api,"rules":_vm.rules,"type":"HN","showFooter":1 == 1,"footerTotalCols":_vm.footerTotalCols}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }